import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { http } from '../../../utils/clientHttp'
import Text from '../../Text'
import { CircularProgress, Collapse } from '@mui/material'
import { useDetectMobile } from '../../../utils/hooks/useDetectMobile'
import Cta from '../../Cta'
import { roundToNearestTen } from '../../../utils/numbers'

function CoachesList({ backgroundColor, textColor, maxCoachesShownOnMobile = 30 }) {
  const colorProps = { backgroundColor: backgroundColor.value, color: textColor.value }

  const [isMobile] = useDetectMobile(991)
  const [showHiddenCoaches, setShowHiddenCoaches] = useState(false)

  const [coaches, setCoaches] = useState(null)

  useEffect(() => {
    http.get('/api/getCoaches')
      .then((response) => setCoaches(response.data))
      .catch(() => setCoaches([]))
  }, [])

  if (!(coaches && coaches.length)) {
    return (
      <div className={styles.loading} style={colorProps}>
        <CircularProgress color="inherit"/>
      </div>
    )
  }

  return (
    <div className={styles.wrapper} style={colorProps}>
      <div className={styles.contentWrapper}>
        <Text type="h3">{`Choose from ${roundToNearestTen(coaches.length)}+ coaches`}</Text>
          <div className={styles.coachListWrapper}>
            {
              (() => {
                if (!isMobile) {
                  return renderCoachesList(coaches)
                } else {
                  const coachesShown = coaches.slice(0, maxCoachesShownOnMobile)
                  const coachesHidden = coaches.slice(maxCoachesShownOnMobile)

                  return <>
                    { renderCoachesList(coachesShown) }
                    <Collapse in={showHiddenCoaches} timeout={{ enter: 500, exit: 250 }}>
                      { renderCoachesList(coachesHidden) }
                    </Collapse>
                  </>
                }
              }) ()
            }
          </div>
        <div className={isMobile ? styles.viewMoreCtaWrapper : styles.viewMoreCtaWrapperHidden}>
          <Cta
            dark
            title={showHiddenCoaches ? 'Show less' : `View ${coaches.length - maxCoachesShownOnMobile} more`}
            onClick={() => setShowHiddenCoaches(!showHiddenCoaches)}
          />
        </div>
      </div>
    </div>
  )
}

const renderCoachesList = (coachesList) => {
  return (
    <div className={styles.coachesWrapper}>
      {
        coachesList.map(c => (
          <div className={styles.coachNameWrapper} key={c}>
            <Text type="body-short-1">{c}</Text>
          </div>
        ))
      }
    </div>
  )
}

export default CoachesList
